export const money = (n: number) =>
  n.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });

export const formatDate = (iso: string) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const formatDateTimeMs = (ms: number) =>
  new Date(ms).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

export const hourLabel = (hour24: number) => {
  const h = ((hour24 + 11) % 12) + 1;
  return `${h}:00 ${hour24 >= 12 ? 'PM' : 'AM'}`;
};

export const durationLabel = (hours: number) =>
  hours >= 8 ? 'Full day' : hours === 1 ? '1 hour' : `~${hours} hours`;

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
